<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4HBWbM/tc-custom/9780765395283.jpg?1738254612387" alt="This image is the cover for the book Child of a Mad God, Tales of the Coven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Child of a Mad God, Tales of the Coven
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A young witch must harness her power to confront a deadly demon in the </b><i><b>New York Times</b></i><b> bestselling author's fantasy series debut.</b></p><p>After losing her parents, Aoleyn is left to fend for herself among a tribe of vicious barbarians. But even as she is bound by rigid traditions, she dreams of escaping into the world beyond her mountain home.<br/><br/>To achieve the freedom she desires, she must learn to wield the Song of Usgar, the mysterious power used by her coven. Thankfully, Aoleyn may be the strongest witch to have ever lived, but magic comes at price. Her abilities have caught the eye of the tribe's brutish warlord. And even more terrifying is the witch-hunting demon of the mountain who is drawn to Aoleyn’s talent like a beacon in the night.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. A. Salvatore
      </h2>
      
      <p class="authorDescription body article">R. A. Salvatore&rsquo;s first book,&#160;<I>The Crystal Shard</I>, was published in 1988; in 1990 his third novel,&#160;<I>The Halfling&rsquo;s Gem,&#160;</I>hit the&#160;<I>New York Times&#160;</I>bestseller list. Since then he has written more than sixty novels, which have sold more than thirty million copies worldwide. In addition, Salvatore has numerous game credits, making him one of the most important figures in modern epic fantasy. Among his books are numerous titles in the saga of dark elf Drizzt Do&rsquo;Urden, the Coven series, the Crimson Shadow trilogy, and many more.<BR /> &#160;<BR /> Salvatore spends a good deal of time speaking to schools and library groups, encouraging people, particularly young people, to read. He enjoys a broad range of literary writers, from James Joyce to Dante and Chaucer, and counts among his favorite genre literary influences Ian Fleming, Arthur Conan Doyle, Fritz Leiber, and J.&#160;R.&#160;R. Tolkien. Salvatore makes his home in Massachusetts, with his wife, Diane, and their dogs. His gaming group still meets on Sunday nights.<BR /> &#160;<BR /> He is currently working on more novels set in the Demonwars and Dark Elf series.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4853bebc